import { render, staticRenderFns } from "./SContractView.vue?vue&type=template&id=bee5daca&scoped=true&"
import script from "./SContractView.vue?vue&type=script&async=true&lang=js&"
export * from "./SContractView.vue?vue&type=script&async=true&lang=js&"
import style0 from "./SContractView.vue?vue&type=style&index=0&id=bee5daca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee5daca",
  null
  
)

export default component.exports